<template>
  <div>
    <v-container class="mt-8">
      <v-row>
        <v-col class="col-12 col-sm-7">
          <p_agent :pd="siteConf.Link" />
        </v-col>
        <v-col class="col-12 col-sm-5">
          <v-card>
            <v-card-title>{{$t('labels.ResetPassword')}}</v-card-title>
            <v-card-text>
              <v-text-field
                label="Password"
                type="password"
                v-model="resetFrm.Password"
               
              >  
              </v-text-field>
              <div v-if="passwordHint" v-html="passwordHint" />    

              <v-text-field
                label="Confirm Password"
                v-model="resetFrm.ConfirmPassword"
                type="password"
                :error-messages="passwordError"
                :error="passwordError!=''"
              />
            </v-card-text>

            <v-card-text>
              <div class="text-center">
                <v-btn
                  :disabled="!isFrmValid"
                  @click="resetPWD"
                  class="mx-auto mb-5"
                  color="primary"
                >{{$t('labels.ResetPassword')}}</v-btn>
              </div>
              <div class="text-center">
                <v-btn
                  @click="backToLoginPage"
                  class="mx-auto"
                  text
                >{{$t('labels.ReturnToLoginPage')}}</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <div class="loading" v-if="loadFlag">Loading&#8230;</div>
  </div>
</template>

<script>
import localStorageSvc from "@/services/localStorage";
import p_agent from "@/pages/app/agent/home/agentInfo";
import dataSvc from "@/services/dataService";
export default {
  components: {
    p_agent
  },
  data() {
    return {      
      loadFlag: false,
      siteID: this.$route.params.siteid,
      resetFrm: {
        Password: null,
        ConfirmPassword: null,
        SiteID: this.$route.params.siteid,
        CacheKey: this.$route.params.cachekey      
      },
      siteConf: {
        user: {},
        site: {}
      }
    };
  },
  computed: {
    isFrmValid() {
      if (this.resetFrm.Password && this.resetFrm.ConfirmPassword) {
        if ( this.passwordError == "") 
            return true;         
      }
      return false;
    },
    passwordHint() {
      return this.$t("labels.UserPasswordHint");      
    },
    passwordError() {
      if (this.resetFrm.ConfirmPassword) {
        if (this.resetFrm.ConfirmPassword != this.resetFrm.Password) {
          return this.$t("labels.ConfirmPasswordNotMatch");
        }
      }
      return "";
    }
  },
  methods: {
    backToLoginPage() {
      this.$router.push("/" + this.siteID + "/home");
    },
    resetPWD() {
      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post("/api/MTGAPPUserResetPassword", this.resetFrm)
        .then(res => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.$alert(
              this.$t("labels.ResetPassword"),
              this.$t("labels.ResetPasswordSuccess"),
              ()=>{
                this.$router.push('/' + this.siteID);
              }
            );
          } else {
            this.$alert(
              this.$t("labels.Warning"),
              this.$t("errors." + res.data.ReturnStatus.ReturnMessage)
            );
          }
        });
    },
    loadPage() {
      this.loadFlag = true;
      dataSvc
        .getSiteConf(this.siteID)
        .then(res => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.siteConf = res.data;
          } else {
            this.$router.push("/");
          }
        })
        .catch(() => {
          this.$router.push("/");
        });
    }
  },
  created() {
    localStorageSvc.removeUser();
    this.loadPage();
  }
};

// Helptrain123 helptrain*123 Helptrain@123
</script>

<style>
</style>